import { useCssVar } from "@vueuse/core";
export default {
    namespaced: true,
    state: {
        isToolbarsCollapsed: false,
        isToolbarsCollapsedRight: true,
        configModeStatus: false,
    },
    getters: {},
    mutations: {
        UPDATE_TOOLBARS_COLLAPSED(state, val) {
            localStorage.setItem('toolbarsCollapsed', val)
            state.isToolbarsCollapsed = val
        },
        UPDATE_TOOLBARS_COLLAPSED_RIGHT(state, val) {
          localStorage.setItem('isToolbarsCollapsedRight', val)
          state.isToolbarsCollapsedRight = val
      },
        TOGGLE_CONFIG_MODE(state, val) {
            state.configModeStatus = val
        },
    },
    actions: {
        initializeStore(ctx) {
            ctx.commit(
                'UPDATE_TOOLBARS_COLLAPSED',
                !!JSON.parse(localStorage.getItem('toolbarsCollapsed'))
            );
        },
        setUserLogos(ctx, user) {
            const baseUrl = window.location.origin + '/';
            let sboLoadingLogoUrl = baseUrl + "log-psim-without-text.png";
            const isSba = ["sba@sbo.com", "pocosasco@sbo.com"].includes(user?.email)
            const bgColorLoading = user?.config?.preferences?.theme?.config?.appColors?.primary?.value ?? "#1b3d5e"
            if (isSba) {
                sboLoadingLogoUrl = baseUrl + "SBA_logo.svg"
            }
            if (user?.config?.preferences?.theme?.config?.imageLogoLoading?.url) {
                sboLoadingLogoUrl = user?.config?.preferences?.theme?.config?.imageLogoLoading?.url
            }

            localStorage.setItem("sboLoadingLogoUrl", sboLoadingLogoUrl);
            localStorage.setItem("sboLoadingBgColor", bgColorLoading);
        },
        setAppColors({ commit }, preferences) {
            if(preferences.theme) {
              const colorsConfig = preferences.theme.config.appColors
              Object.entries(colorsConfig).forEach(color => {
                const colorVariable = useCssVar(`--${color[1].name}`, document.documentElement)
                colorVariable.value = color[1].value
              });
            }
        }
    },
}
